<template>
    <div class="footer__contact">
        <div class="contact">
            <contact-head :contactFl="getFlMainContact[0]"
                          :contactUl="getUlMainContact[0]"
                          :contactSTS="getSTSMainContact[0]">>
            </contact-head>
            <div id="contactBody" class="contact__body accordion-body collapse block">
                <div class="contact__body-inner contact__body-inner--list accordion-body__inner">
                    <div class="contact-section">
                        <div class="contact-section__head h3">
                            <a href="#contactSection_1" class="contact-section__toggle link link--pseudo collapse-link" data-toggle="collapse" aria-expanded="true">
                                <span class="link__text">Адреса центров обслуживания клиентов</span>
                                <span class="link__icon fab-icon">
                                    <i class="icon icon--angle-down"></i>
                                </span>
                            </a>
                        </div>
                        <div id="contactSection_1" class="contact-section__body accordion-body collapse in" aria-expanded="true">
                            <div class="contact-section__inner accordion-body__inner">
                                <div class="contact-section__ctrl">
                                    <div class="subnav-wrap swiper-container js-nav-slider" data-shown-slider>
                                        <ul class="subnav swiper-wrapper">
                                            <li v-for="item in getClientServiceType"
                                                :key="item.id"
                                                class="subnav__item swiper-slide"
                                                v-if="existsCategotyType(item.id)"
                                                v-bind:class="{ active: getSelectedClientServiceType(item.id) }">
                                                <a href="" v-on:click.prevent="selectClientServiceType(item.id)"
                                                   class="subnav__link link h4">
                                                    {{ item.name }}
                                                </a>
                                            </li>
                                        </ul>
                                        <!--<div class="phone-list__nav">
                                            <div class="slider-ctrl">
                                                <a href="" class="button-icon button-icon--th-inverse js-slider-prev"><i class="icon icon--arrow-left"></i></a>
                                                <a href="" class="button-icon button-icon--th-inverse js-slider-next"><i class="icon icon--arrow-right"></i></a>
                                            </div>
                                        </div>-->
                                    </div>
                                </div>
                                <div class="contact-card-list contact-card-list--scroller block block-wrap">
                                    <div class="contact-card-list__inner">
                                        <contact-card-selector v-for="item in getFilteredClientServices" 
                                                               :item="item"
                                                               :key="item.id">
                                        </contact-card-selector>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="contact-section">
                        <div class="contact-section__head h3">
                            <a href="#contactSection_2" class="contact-section__toggle link link--pseudo collapse-link collapsed" data-toggle="collapse">
                                <span class="link__text">Аварийно–диспетчерская служба</span>
                                <span class="link__icon fab-icon">
                                    <i class="icon icon--angle-down"></i>
                                </span>
                            </a>
                        </div>
                        <div id="contactSection_2" class="contact-section__body accordion-body collapse">
                            <div class="contact-section__inner accordion-body__inner">
                                <div class="phone-list block">
                                    <div class="phone-list__panel">
                                        <div class="phone-list__tabs">
                                            <div class="subnav-wrap swiper-container js-nav-slider" data-shown-slider>
                                                <ul class="subnav swiper-wrapper">
                                                    <li v-for="item in getDistricts"
                                                        :key="item.DistrictId"
                                                        class="subnav__item swiper-slide"
                                                        v-bind:class="{ active: getSelectedOptionDistrict(item.DistrictId) }">
                                                        <a href=""
                                                           v-on:click.prevent="selectDistrict(item.DistrictId)"
                                                           class="subnav__link link h4"
                                                           data-toggle="tab">
                                                            {{ item.DistrictName }}
                                                        </a>
                                                    </li>
                                                </ul>
                                                <!--<div class="phone-list__nav">
                                                    <div class="slider-ctrl">
                                                        <a href="" class="button-icon button-icon--th-inverse js-slider-prev"><i class="icon icon--arrow-left"></i></a>
                                                        <a href="" class="button-icon button-icon--th-inverse js-slider-next"><i class="icon icon--arrow-right"></i></a>
                                                    </div>
                                                </div>-->
                                            </div>
                                        </div>
                                    </div>
                                    <phone-list :items="getFilteredEmergencyControlRoomInfo" :selectedDistrict="getSelectedDistrict"></phone-list>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="contact-section" v-if="getConnectHeatSystem != undefind && getConnectHeatSystem != null">
                        <div class="contact-section__head h3">
                            <a href="#contactSection_3" class="contact-section__toggle link link--pseudo collapse-link collapsed" data-toggle="collapse" id="footerlink">
                                <span class="link__text">Подключение к системам теплоснабжения</span>
                                <span class="link__icon fab-icon">
                                    <i class="icon icon--angle-down"></i>
                                </span>
                            </a>
                        </div>
                        <div id="contactSection_3" class="contact-section__body accordion-body collapse">
                            <div class="contact-section__inner accordion-body__inner">
                                <div class="contact-card-list__inner">
                                    <!--v-for="item in getConnectHeatSystem"-->
                                    <contact-card-selector :item="getConnectHeatSystem"
                                                           :key="getConnectHeatSystem.id">
                                    </contact-card-selector>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import contactHead from './FooterContactHead.vue'
    import contactCardSelector from './ContactCardItemSelector.vue'
    import phoneList from './PhoneList.vue'

    export default {
        components: {
            'contact-head': contactHead,
            'contact-card-selector': contactCardSelector,
            'phone-list': phoneList
        },
        data: function () {
            return {
                clientServiceType: [
                    {
                        name: 'Все',
                        id: 0
                    },
                    {
                        name: 'Физ. лица',
                        id: 2
                    },
                    {
                        name: 'Юр. лица',
                        id: 4
                    },
                    {
                        name: 'Подключение к сетям',
                        id: 6
                    },
                    {
                        name: 'ОСП ПАО "Сбербанк России"',
                        id: 8
                    }
                ],
                parsedCities: [],
                selectedDistrict: 0,
                selectedClientServiceTypeId: 0
            }
        },
        created: function () {
            this.parsedCities = JSON.parse(this.cities);
        },
        props: {
            cities: String
        },
        computed: {
            getCurrentContacts() {
                return this.parsedCities;
            },
            getEmergencyControlRoomInfo() {
                return this.sortClientService(this.getCurrentContacts.Contacts.filter(item => item.ContactType === 8 && !item.IsDeleted));
            },
            getClientServices() {
                return this.sortClientService(this.getCurrentContacts.ClientServices.filter(item => !item.IsDeleted));
            },
            getFilteredClientServices() {
                return this.getClientServices.filter(item => (this.getSelectedClientServiceTypeId == 0 ||
                                                              item.CategoryType == this.getSelectedClientServiceTypeId) &&
                                                              item.ClientServiceType !== 1 &&
                                                              item.ClientServiceType !== 11 &&
                                                              item.ClientServiceType !== 12);
            },
            getFilteredEmergencyControlRoomInfo() {
                return this.getEmergencyControlRoomInfo.filter(item => (this.getSelectedDistrict == 0 || item.DistrictId == this.getSelectedDistrict));
            },
            getConnectHeatSystem() {
                return this.sortClientService(this.getClientServices.filter(item => item.ClientServiceType === 1 && !item.IsDeleted))[0];
            },
            getFlContacts() {
                return this.getClientServices.filter(item => item.CategoryType === 2 && !item.IsDeleted);
            },
            getUlContacts() {
                return this.getClientServices.filter(item => item.CategoryType === 4 && !item.IsDeleted);
            },
            getSTSContacts() {
                return this.getClientServices.filter(item => item.CategoryType === 6 && !item.IsDeleted);
            },
            checkLoadData() {
                return !!(this.getCurrentContacts.length);
            },
            getDistricts: function () {
                let districts = this.getCurrentContacts.Districts;
                districts.unshift({ CityId: 0, DistrictId: 0, DistrictName: "Все районы" })
                return districts;
            },
            getSelectedDistrict: function () {
                return this.selectedDistrict;
            },
            getSelectedClientServiceTypeId() {
                return this.selectedClientServiceTypeId;
            },
            getClientServiceType: function () {
                return this.clientServiceType
            },
            getFlMainContact: function () {
                let result = this.sortClientService(this.getClientServices.filter(item => item.ClientServiceType === 11 && !item.IsDeleted));
                if (result.length) return result;
                return this.getFlContacts;
            },
            getUlMainContact: function () {
                let result = this.sortClientService(this.getClientServices.filter(item => item.ClientServiceType === 12 && !item.IsDeleted));
                if (result.length) return result;
                return this.getUlContacts;
            },
            getSTSMainContact: function () {
                let result = this.sortClientService(this.getClientServices.filter(item => item.ClientServiceType === 1 && !item.IsDeleted));
                if (result.length) return result;
                return this.getSTSContacts;
            },
        },
        methods: {
            sortClientService: function (arr) {
                return arr.sort((a, b) => (Number(a.Order) > Number(b.Order)) | Number(a.Order) == Number(b.Order) ? 1 : -1);
            },
            selectDistrict(value) {
                this.selectedDistrict = value;
            },
            selectClientServiceType(value) {
                this.selectedClientServiceTypeId = value;
            },
            existsCategotyType(value) {
                return this.getClientServices.some(item => value == 0 || item.CategoryType == value)
            },
            getSelectedClientServiceType(value) {
                return !!(value == this.getSelectedClientServiceTypeId)
            },
            getSelectedOptionDistrict(value) {
                return !!(value == this.getSelectedDistrict)
            }
        }
    }

    $(document).ready(function () {
        let location = window.location.pathname;
        let flag = location.includes("STS");
        if (flag) {
            $('#contactSection_1').collapse('hide');
            $('#contactSection_2').collapse('hide');
            $('#contactSection_3').collapse('show');
        }
    });

    $('#clickFooter').click(function (e) {
        $('#contactBody').collapse('show');
        $('#contactSection_1').collapse('hide');
        $('#contactSection_2').collapse('hide');
        $('#contactSection_3').collapse('show');
    });

    $(document).ready(function () {
        $("#contactBody").on('shown.bs.collapse', function () {
            window.location = "#contactSection_3";
        });
    });

    

</script>



// WEBPACK FOOTER //
// Scripts/app/FooterContactInfo/FooterContactInfo.vue